const progressStyles = {
  baseStyle: {
    filledTrack: {
      bg: 'primary',
    },
  },
}

export default progressStyles
